import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Payment() {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const paymentMethods = [
    { id: 'mada', name: 'مدى', icon: 'ri-bank-card-line', color: 'from-green-500 to-green-600' },
    { id: 'visa', name: 'فيزا / ماستركارد', icon: 'ri-bank-card-2-line', color: 'from-blue-500 to-blue-600' },
    { id: 'apple-pay', name: 'Apple Pay', icon: 'ri-apple-fill', color: 'from-gray-700 to-gray-900' },
    { id: 'cash', name: 'الدفع عند الاستلام', icon: 'ri-money-dollar-circle-line', color: 'from-orange-500 to-orange-600' }
  ];

  const handlePayment = () => {
    setShowSuccess(true);
    setTimeout(() => {
      navigate('/tracking');
    }, 2500);
  };

  if (showSuccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#4CAF50] to-[#45a049] flex flex-col items-center justify-center px-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
        <div className="w-32 h-32 bg-white rounded-full flex items-center justify-center mb-6 animate-bounce-slow">
          <i className="ri-checkbox-circle-fill text-[#4CAF50] text-7xl"></i>
        </div>
        <h2 className="text-white text-2xl font-bold mb-2 text-center">تم الدفع بنجاح!</h2>
        <p className="text-white/90 text-sm text-center">جاري تحويلك لمتابعة الطلب...</p>

        <style>{`
          @keyframes bounce-slow {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
          }
          .animate-bounce-slow {
            animation: bounce-slow 1s ease-in-out infinite;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/quotes')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
          </button>
          <h1 className="text-[#212121] text-lg font-bold">الدفع</h1>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 px-4">
        {/* Order Summary */}
        <div className="bg-white rounded-2xl p-5 mb-4">
          <h3 className="text-[#212121] font-bold mb-4">ملخص الطلب</h3>
          <div className="space-y-3 mb-4 pb-4 border-b border-gray-200">
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-600">المنتجات (3 منتجات)</span>
              <span className="text-[#212121] font-bold">152 ر.س</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-600">رسوم التوصيل</span>
              <span className="text-[#212121] font-bold">15 ر.س</span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[#212121] font-bold text-lg">الإجمالي</span>
            <span className="text-[#0D47A1] font-bold text-2xl">167 ر.س</span>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="mb-4">
          <h3 className="text-[#212121] font-bold mb-4">طريقة الدفع</h3>
          <div className="space-y-3">
            {paymentMethods.map((method) => (
              <button
                key={method.id}
                onClick={() => setSelectedMethod(method.id)}
                className={`w-full bg-white rounded-2xl p-4 flex items-center gap-4 transition-all ${
                  selectedMethod === method.id ? 'border-2 border-[#0D47A1] shadow-lg' : 'border-2 border-transparent'
                }`}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${method.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <i className={`${method.icon} text-white text-2xl`}></i>
                </div>
                <span className="text-[#212121] font-bold flex-1 text-right">{method.name}</span>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selectedMethod === method.id ? 'border-[#0D47A1]' : 'border-gray-300'
                }`}>
                  {selectedMethod === method.id && (
                    <div className="w-3.5 h-3.5 bg-[#0D47A1] rounded-full"></div>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Security Notice */}
        <div className="bg-gradient-to-r from-[#0D47A1]/10 to-[#1976D2]/10 border border-[#0D47A1]/20 rounded-2xl p-4 flex items-start gap-3">
          <i className="ri-shield-check-fill text-[#0D47A1] text-xl flex-shrink-0 mt-0.5"></i>
          <div>
            <h4 className="text-[#212121] font-bold text-sm mb-1">دفع آمن ومحمي</h4>
            <p className="text-gray-600 text-xs leading-relaxed">
              جميع المعاملات مشفرة ومحمية بأعلى معايير الأمان
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50">
        <button
          onClick={handlePayment}
          disabled={!selectedMethod}
          className={`w-full py-4 rounded-xl font-bold text-lg shadow-lg active:scale-95 transition-transform ${
            selectedMethod
              ? 'bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {selectedMethod === 'cash' ? 'تأكيد الطلب' : 'ادفع الآن - 167 ر.س'}
        </button>
      </div>
    </div>
  );
}